import type { QuoteDocument } from 'paintscout'

/**
 * Fetch the latest quote doc via the context's refetchQuote (customer view only — undefined in the
 * app-side preview). Fail-open: resolves null when unavailable or on fetch errors, and callers fall
 * back to the state they have — a blip must never block a legitimate payment; the server-side
 * paymentError lock is the backstop.
 */
export async function fetchFreshQuote(
  refetchQuote?: () => Promise<QuoteDocument | null>
): Promise<QuoteDocument | null> {
  if (!refetchQuote) return null
  try {
    return await refetchQuote()
  } catch {
    return null
  }
}

/**
 * Build the `checkPaymentBlocked` dialog prop: a fresh-state sample taken immediately before
 * PayFields.submit() (card entry takes minutes — exactly the window where a delayed paymentError
 * write from a prior attempt lands). Returns undefined when no refetch is available, and the check
 * itself fails open (false) on fetch errors.
 */
export function makeCheckPaymentBlocked(
  refetchQuote?: () => Promise<QuoteDocument | null>
): (() => Promise<boolean>) | undefined {
  if (!refetchQuote) return undefined
  return async () => !!(await fetchFreshQuote(refetchQuote))?.paymentError
}
